import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';


import translationEN from './locales/en';
import translationIT from './locales/it';


const resources = {
    en: translationEN,
    it: translationIT,
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'it',
        load: 'languageOnly',
        defaultNS: 'translations',
        fallbackLng: 'it',
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        },
        getAsync: false,
    });


export default i18n